import { render, staticRenderFns } from "./EmployeesByEducation.vue?vue&type=template&id=7865b5b4&scoped=true&"
import script from "./EmployeesByEducation.vue?vue&type=script&lang=js&"
export * from "./EmployeesByEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7865b5b4",
  null
  
)

export default component.exports